import { createSlice } from '@reduxjs/toolkit';
import { ISpiCloudSettingsProps } from './interfaces';

const devUrl = 'https://sci-pairing-api-dev.integrations-nonprod.mx51.io/v1/progress-pairing';
const qaUrl = 'https://sci-pairing-api-qa.integrations-nonprod.mx51.io/v1/progress-pairing';
const liveUrl = 'https://sci-pairing-api.integrations.mx51.io/v1/progress-pairing';

const spiCloudSettingsSlice = createSlice({
  name: 'spiCloudSettings',
  initialState: {
    dev: {
      apiKey: '',
      secretPartA: '',
    },
    qa: {
      apiKey: '',
      secretPartA: '',
    },
    live: {
      apiKey: '',
      secretPartA: '',
    },
    other: {
      apiBaseUrl: '',
      apiKey: '',
      secretPartA: '',
    },
  },
  reducers: {
    resetSpiCloudSettingsSlice() {
      return {
        dev: {
          apiKey: '',
          secretPartA: '',
        },
        qa: {
          apiKey: '',
          secretPartA: '',
        },
        live: {
          apiKey: '',
          secretPartA: '',
        },
        other: {
          apiBaseUrl: '',
          apiKey: '',
          secretPartA: '',
        },
      };
    },
    setPairingSettings(state: ISpiCloudSettingsProps, action: { payload: ISpiCloudSettingsProps }) {
      state.dev = {
        apiKey: action.payload.dev.apiKey,
        secretPartA: action.payload.dev.secretPartA,
      };
      state.qa = {
        apiKey: action.payload.qa.apiKey,
        secretPartA: action.payload.qa.secretPartA,
      };
      state.live = {
        apiKey: action.payload.live.apiKey,
        secretPartA: action.payload.live.secretPartA,
      };
      state.other = {
        apiBaseUrl: action.payload.other.apiBaseUrl,
        apiKey: action.payload.other.apiKey,
        secretPartA: action.payload.other.secretPartA,
      };
    },
  },
});

export const { resetSpiCloudSettingsSlice, setPairingSettings } = spiCloudSettingsSlice.actions;

export default spiCloudSettingsSlice.reducer;
